"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_BASE_URL = exports.BASE_URL = void 0;
var environmentURL = window.location.origin;
// We need to get the origin with protocol and ports if process env is development
if (process.env.NODE_ENV === 'development') {
    environmentURL = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
}
exports.BASE_URL = "" + environmentURL;
exports.API_BASE_URL = exports.BASE_URL + "/api";
